/**
 * One of the arranger's menus: its label, then the choice made, each choice named and
 * explained by `names` so the menu and its title never say different things.
 */

import { LABEL, SELECT } from "./Chrome";

/** What a choice is called on its menu, and what it does, said in its title. */
export type Named<T extends string> = Readonly<Record<T, { label: string; title: string }>>;

export default function ArrangeMenu<T extends string>({
  label,
  value,
  values,
  names,
  shut,
  onPick,
}: {
  readonly label: string;
  readonly value: T;
  readonly values: readonly T[];
  readonly names: Named<T>;
  /** Why the menu is shut, where it is; its title then says so. */
  readonly shut?: string;
  onPick(value: T): void;
}): JSX.Element {
  return (
    <>
      <span className={LABEL}>{label}</span>
      <select
        value={value}
        disabled={shut !== undefined}
        title={shut ?? names[value].title}
        onChange={(event) => {
          const picked = values.find((one) => one === event.target.value);
          if (picked !== undefined) onPick(picked);
        }}
        className={`${SELECT} disabled:opacity-40`}
      >
        {values.map((one) => (
          <option key={one} value={one} title={names[one].title}>
            {names[one].label}
          </option>
        ))}
      </select>
    </>
  );
}
